import React from "react";
import styled from "styled-components";
import { CircleMinus } from "@sonder/ui/source/icons";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { Input } from "@sonder/ui/source/styled/fragments/Input";
import { Label } from "@sonder/ui/source/styled/fragments/Label";
import { UnitConsumables } from "core/queries/GetUnitConsumables";

const StyledContainer = styled.div`
  align-items: center;
  display: grid;
  grid-column-gap: 0.5rem;
  grid-row-gap: 0.5rem;
  grid-template-columns: 1fr auto 1fr auto;
  margin-bottom: 1rem;
`;

interface Props {
  consumable: UnitConsumables;
  value: number | string;
  onChange: (value: string) => void;
  onRemove: (consumable: UnitConsumables) => void;
}

export const TaskConsumableInput = ({
  consumable,
  value,
  onChange,
  onRemove,
}: Props) => {
  const isValueAboveMaxQuantity = Boolean(
    value &&
      consumable?.suggestedMaxQuantity &&
      value > consumable?.suggestedMaxQuantity,
  );

  return (
    <StyledContainer>
      <Label>{consumable?.nameLocalized}</Label>
      <Label>{consumable?.suggestedMaxQuantity} Max</Label>
      <Input
        type="number"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      <Button iconOnly onClick={() => onRemove(consumable)}>
        <CircleMinus />
      </Button>
      {isValueAboveMaxQuantity && (
        <>
          <span />
          <span />
          <span>Quantity greater than max</span>
        </>
      )}
    </StyledContainer>
  );
};
